<script setup lang="ts">
import { kanbanBoardStickyChipClicked } from "@/analytics/events/kanban";
import { trackEvent } from "@/analytics/track";
import BaseTooltip from "@/components/ui/BaseTooltip/BaseTooltip.vue";

const props = defineProps<{
  name: string; // used for analytics tracking
  as?: string;
  text?: string;
  tooltipText?: string;
}>();

const handleClick = () => {
  trackEvent(kanbanBoardStickyChipClicked(props.name));
};
</script>

<template>
  <component :is="as ?? 'div'" class="flow-sticky-chip" @click="handleClick">
    <BaseTooltip v-if="tooltipText" :text="tooltipText">
      <slot>
        <span class="text">{{ text }}</span>
      </slot>
      <template #content>
        {{ tooltipText }}
      </template>
    </BaseTooltip>
    <slot v-else />
  </component>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";
@use "@/styles/mixins/typography";
@use "@/styles/font";
@use "@/styles/mixins/utils";

.flow-sticky-chip {
  @include typography.small("semi-bold");

  display: inline-flex;
  align-items: center;
  height: 20px;
  user-select: none;
  border-radius: 4px;
  max-width: 100%;
  padding: 2px 4px;
  min-width: 0;
  position: relative;
  overflow: hidden;

  :deep(.base-tooltip) {
    max-width: 100%;
  }

  .text {
    @include utils.ellipsis;
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: currentcolor;
    opacity: 0.1;
    pointer-events: none;
  }
}
</style>
